import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'

const OfferEMI = types.model('OfferEMI', {
  bankId: types.optional(types.string, ''),
  tenure: types.optional(types.string, ''),
  bankEmiId: types.optional(types.string, ''),
})

const OfferPeriod = types.model('OfferPeriod', {
  timeDuration: types.optional(types.string, ''),
  startDate: types.optional(types.string, ''),
  endDate: types.optional(types.string, ''),
})
const Product = types.model('Product', {
  categoryId1: types.optional(types.string, ''),
  categoryId2: types.optional(types.string, ''),
  categoryId3: types.optional(types.string, ''),
  categoryId4: types.optional(types.string, ''),
  categoryId5: types.optional(types.string, ''),
  productId: types.optional(types.string, ''),
})

const InstantDiscountAmount = types.model('InstantDiscountAmount', {
  amount: types.optional(types.number, 0),
})

const CashBackAmount = types.model('CashBackAmount', {
  amount: types.optional(types.number, 0),
})

const InstantDiscountUnit = types.model('InstantDiscountUnit', {
  type: types.optional(types.number, 0),
  value: types.optional(types.string, ''),
  maxValue: types.optional(types.number, 0),
})

const CashBackUnit = types.model('CashBackUnit', {
  type: types.optional(types.number, 0),
  value: types.optional(types.string, ''),
  maxValue: types.optional(types.number, 0),
})

const Offer = types.model('Offer', {
  offerPeriod: types.optional(OfferPeriod, {}),
  startDate: types.optional(types.string, ''),
  endDate: types.optional(types.string, ''),
  code: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  status: types.optional(types.number, 0),
  eligibility: types.optional(types.number, 0),
  offerType: types.optional(types.number, 0),
  paymentModeType: types.optional(types.number, 0),
  paymentModeSubType: types.optional(types.number, 0),
  instantDiscountAmount: types.optional(InstantDiscountAmount, {}),
  cashBackAmount: types.optional(CashBackAmount, {}),
  instantDiscountUnit: types.optional(InstantDiscountUnit, {}),
  cashBackUnit: types.optional(CashBackUnit, {}),
  emi: types.array(OfferEMI),
  termsConditions: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  referenceId: types.optional(types.string, ''),
  products: types.array(Product),
  bankIds: types.optional(types.array(types.string), []),
})

export type WalletType = Instance<typeof Offer>
export { Offer }
